import Vue from 'vue'
import ElementUI from 'element-ui'
import App from './App'
import router from './router'
import store from './store'
import './permission'
import 'element-ui/lib/theme-chalk/base.css'
import 'element-ui/lib/theme-chalk/index.css'
import './icons'
import plugins from './plugins'
import * as filters from './filters'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
import i18n from './locales/vueIN'
import Pagination from "@/components/Pagination";
import { getDicts } from "@/api/dict/data";
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree } from "@/utils/ruoyi";
import Editor from "@/components/Editor"
import DictTag from '@/components/DictTag'
import DictData from '@/components/DictData'
import debounce from "@/utils/debounce"
import watermark from "@/utils/watermark"
// 完整加载
import VueLuckyCanvas from '@lucky-canvas/vue'
import positiveNumberDirective from '@/utils/positiveNumberDirective';


import { Message } from 'element-ui';
const $message = options => {
  return Message({
    ...options,
    offset: 80
  });
};
 
//重写方法,将offset写入options
['success', 'warning', 'info', 'error'].forEach(type => {
  $message[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options,
        offset: 80
      };
    }
    options.type = type;
    return Message(options);
  };
});


Vue.directive('positive-number', positiveNumberDirective);
Vue.use(VueLuckyCanvas)
Vue.use(debounce.debounce)
Vue.use(watermark.watermark)
Vue.prototype.getDicts = getDicts
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.handleTree = handleTree
Vue.prototype.parseTime = parseTime

Vue.component('DictTag', DictTag)
Vue.component('Editor', Editor)

Vue.config.productionTip = false
Vue.prototype.bus = new Vue()

Vue.use(ElementUI)
Vue.use(plugins)
Vue.component('Pagination', Pagination)
Vue.component(CollapseTransition.name, CollapseTransition)

//将$message挂载到this上
Vue.prototype.$message = $message;
//不加这行代码运行this.$message.closeAll时会报错
Vue.prototype.$message.closeAll = Message.closeAll; 
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

let vue = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})

Vue.use(vue)
DictData.install()



// WEBPACK FOOTER //
// ./src/main.js